import React from "react";

const InputGroupWithResetValue = ({
  props,
  data,
  resetDefault,
  inputChange,
  error,
  disabled = false,
  noBtn = false,
  defferChange = false,
}) => {
  if (data[props.name] === null) resetDefault(props.name, props.defaultValue);

  function actionChange(e) {
    if (!defferChange) {
      inputChange(e);
      return;
    }
    // Saisie atomique via dialog (pattern « valeur réglementée » de Control) :
    // la frappe directe n'est jamais appliquée à l'input.
    var value = window.prompt(
      "Modifier une valeur réglementée",
      data[props.name] || props.defaultValue
    );
    if (value === null) return;
    var parsed = parseFloat(String(value).replace(",", "."));
    if (parsed) {
      e.target.value = parsed;
      inputChange(e);
    } else {
      // Vide, 0 ou non numérique : retour à la valeur par défaut
      resetDefault(props.name, props.defaultValue);
    }
  }

  const isGreater = props.defaultValue > data[props.name];
  const isLess = props.defaultValue < data[props.name];
  const isDiff = isGreater || isLess;

  return (
    <div className="form-group">
      {props.label && (
        <label htmlFor={props.name}>
          {props.label}
          {props.required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      <div className="input-row">
        <div className="input-group">
          <input
            type="text"
            className={
              "form-control " +
              (props.inputClassName ? props.inputClassName : "")
            }
            name={props.name}
            id={props.name}
            value={data[props.name] || props.defaultValue}
            onChange={actionChange}
            aria-label={props.label}
            disabled={disabled ? "disabled" : false}
          />
          {props.symbol && (
            <div className="input-group-append">
              <span className="input-group-text">{props.symbol}</span>
            </div>
          )}
        </div>
        {props.defaultValue ? (
          <button
            type="button"
            className={
              "reset-chip " +
              (isDiff ? "reset-chip-diff " : "") +
              (noBtn ? "d-none" : "")
            }
            onClick={() => resetDefault(props.name, props.defaultValue)}
            disabled={disabled}
            title={"Revenir à la valeur par défaut : " + props.defaultValue}
          >
            <i className="fa fa-undo" />
            {isDiff ? (
              <>
                <span>{props.defaultValue}</span>
                {isGreater ? (
                  <i className="fa fa-caret-up chip-up" />
                ) : (
                  <i className="fa fa-caret-down chip-down" />
                )}
              </>
            ) : (
              <span>=</span>
            )}
          </button>
        ) : null}
      </div>
      <small className="form-text text-danger">{error}</small>
    </div>
  );
};

export default InputGroupWithResetValue;
